module.exports = __webpack_public_path__ + "static/img/shiftHandover1.f2dea4c4.svg";